import React from "react";
import { Typography, Box } from "@mui/material";

const SignupHeader = () => (
  <Box sx={{ mb: 4, textAlign: "center" }}>
    <Typography variant="h4" fontWeight="bold" gutterBottom>
      Let’s Celebrate Together
    </Typography>
    <Typography variant="body2" color="text.secondary">
      Join a world of joy, surprise, and sweet moments 🍰
    </Typography>
  </Box>
);

export default SignupHeader;
